
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/products/vocal_tracks",
      function () {
        return require("private-next-pages/store/products/vocal_tracks.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/products/vocal_tracks"])
      });
    }
  